<span class="status-badge status-badge--{{ statusClass() }}">
  @if (status() === 'PENDING') {
    <mat-spinner diameter="24"></mat-spinner>
  } @else {
    {{ label() }}
  }
</span>
